// Online war entry (docs/ARCHITECTURE.md §15): the matchmaking screen the app flow shows while a rival is found.

import type { MatchAssignment } from '@taxwar/online'
import type { Screen, ScreenFactory } from '../../app/screen'
import type { EdgeOrigin, OnlineWarRequest } from '../../online'
import { MatchmakingScreen } from './MatchmakingScreen'

export function matchmakingScreen(
  request: OnlineWarRequest,
  edge: EdgeOrigin,
  onMatched: (assignment: MatchAssignment) => void,
  onBack: () => void,
): ScreenFactory<Screen> {
  return (context) => new MatchmakingScreen(context, request, edge, onMatched, onBack)
}
